import { render } from "preact";
import { effect } from "@preact/signals";
import "./styles.css";
import { settings, displayPrefs } from "./state/config.js";
import { initSync } from "./state/sync.js";
import { initStore } from "./state/store.js";
import { enrollToken } from "./state/enroll.js";
import { getDeviceToken, hydrateIdentity } from "./state/config.js";
import { pollAssignment } from "./state/assignment.js";
import "./state/install.js"; // beforeinstallprompt früh abfangen (für den Installieren-Button)
import { App } from "./ui/App.js";

// Anzeige-Vorlieben (Spalten/Schriftgröße) als CSS-Variablen auf :root spiegeln.
effect(() => {
  const p = displayPrefs.value;
  document.documentElement.style.setProperty("--grid-cols", String(p.cols));
  document.documentElement.style.setProperty("--item-scale", String(p.fontScale));
});

// Service Worker (App-Shell offline). App läuft auch ohne, Fehler nur loggen.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => console.info("SW registriert:", reg.scope))
      .catch((err) => console.warn("SW-Registrierung fehlgeschlagen:", err));
  });
}

// Boot asynchron: ZUERST die Identität aus IndexedDB rehydrieren (übersteht localStorage-
// Eviction), erst danach über Join/Enroll/Sync entscheiden — sonst würde ein Handy mit geleertem
// localStorage fälschlich im Join-Screen landen und sich neu registrieren (geraet-Wildwuchs).
void (async () => {
  await hydrateIdentity();

  // Ohne Geräte-Token zeigt die App den Code-Screen (Beitritt) — dann kein Venue/Sync-Init.
  const inJoin = !getDeviceToken();

  // Im Registrierungs-/Beitritts-Modus nur den jeweiligen Screen zeigen — kein Venue/Sync-Init.
  if (!enrollToken && !inJoin) {
    initSync(() => settings.value.serverUrl, () => settings.value.venueId);
    // Erst lokal hochfahren, dann die Remote-Zuweisung pollen (übernimmt sie ggf. die Venue).
    void initStore().then(() => pollAssignment());
    // Remote-Zuweisung regelmäßig nachziehen (Betreiber kann live umschalten).
    window.setInterval(() => void pollAssignment(), 30_000);
    // Beim Zurückkehren in die App (Resume) sofort die Zuweisung prüfen — so übernimmt ein gerade
    // zugewiesenes Gerät die Veranstaltung ohne 30-s-Wartezeit.
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") void pollAssignment();
    });
  }

  const root = document.getElementById("app");
  if (root) render(<App />, root);
})();
